// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../SKV.NSW/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../SKV.NSW/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-7{font-size:.875rem}.rounded{border-radius:.5rem}.rounded-lg{border-radius:1rem}.z-index-1{z-index:1}`, "",{"version":3,"sources":["webpack://./../SKV.FrontEnd/src/styles/_custom.scss"],"names":[],"mappings":"AA+WA,MACE,iBAjRa,CAoRf,SACE,mBAjSc,CAoShB,YACE,kBApSiB,CAuSnB,WACE,SAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gray100": `#f7f7f7`,
	"gray200": `#eee`,
	"gray300": `#ddd`,
	"gray400": `#ccc`,
	"gray500": `#aaa`,
	"gray600": `#777`,
	"gray700": `#555`,
	"gray800": `#222`,
	"gray900": `#1c1c1c`,
	"primaryColor": `#a04bcb`,
	"secondaryColor": `#051a49`,
	"successColor": `#12784f`,
	"infoColor": `#1d559d`,
	"warningColor": `#fdc221`,
	"dangerColor": `#b91e1e`,
	"accentColor": `#e60278`,
	"lightColor": `#f7f7f7`,
	"darkColor": `#2e3849`,
	"linkColor": `#2765cf`,
	"mutedColor": `#5a6881`,
	"lineHeightBase": `1.5`,
	"spacer1": `.25rem`,
	"spacer2": `.5rem`,
	"spacer3": `1rem`,
	"spacer4": `1.5rem`,
	"spacer5": `3rem`,
	"spacer6": `5rem`,
	"btnPaddingY": `.75rem`,
	"btnPaddingX": `1rem`,
	"borderRadius": `.5rem`,
	"borderRadiusLg": `1rem`,
	"borderRadiusSm": `.25rem`,
	"boxShadowSm": `0 .125rem .25rem rgba(0,0,0,.075)`,
	"boxShadow": `0 .5rem 1rem rgba(0,0,0,.15)`,
	"boxShadowLg": `0 1rem 3rem rgba(0,0,0,.175)`,
	"xsBreakpoint": `0`,
	"smBreakpoint": `576px`,
	"mdBreakpoint": `768px`,
	"lgBreakpoint": `992px`,
	"xlBreakpoint": `1200px`,
	"smMaxWidth": `540px`,
	"mdMaxWidth": `720px`,
	"lgMaxWidth": `960px`
};
export default ___CSS_LOADER_EXPORT___;
